document.addEventListener("DOMContentLoaded", function () {
  class ProductPopup {
    constructor() {
      this.popupContainer = document.querySelector("#popupContainer");
      this.closePopupBtn = this.popupContainer.querySelector("#closePopupBtn");
      this.addToCartBtn = this.popupContainer.querySelector("#addToCartBtn");
      this.quantityInput = this.popupContainer.querySelector("#quantityInput");
      this.increaseQuantityBtn = this.popupContainer.querySelector(
        "#increaseQuantityBtn"
      );
      this.decreaseQuantityBtn = this.popupContainer.querySelector(
        "#decreaseQuantityBtn"
      );
      this.popupProductImage =
        this.popupContainer.querySelector("#popupProductImage");
      this.popupProductTitle =
        this.popupContainer.querySelector("#popupProductTitle");
      this.popupProductPrice =
        this.popupContainer.querySelector("#popupProductPrice");
      this.showQuantitySpan =
        this.popupContainer.querySelector(".show-quantity");

      this.currentProductId = null;
      this.currentVariantId = null;
      this.availableInventory = 0;
      this.displayInventory = 0;
      this.quantityRules = {
        min: 1,
        max: null,
        increment: 1,
      };

      this.initializeEventListeners();
    }

    initializeEventListeners() {
      document.addEventListener("click", (event) => {
        const openPopupBtn = event.target.closest(".open-popup-btn");
        if (openPopupBtn) {
          this.openPopup(event);
        }
      });

      if (this.closePopupBtn) {
        this.closePopupBtn.addEventListener("click", () => this.closePopup());
      }

      if (this.popupContainer) {
        this.popupContainer.addEventListener("click", (event) => {
          if (event.target === this.popupContainer) {
            this.closePopup();
          }
        });
      }

      if (this.quantityInput) {
        this.quantityInput.addEventListener("change", () =>
          this.validateQuantity()
        );
      }

      if (this.increaseQuantityBtn) {
        this.increaseQuantityBtn.addEventListener("click", (event) => {
          event.preventDefault();
          this.updateQuantity(this.quantityRules.increment);
        });
      }

      if (this.decreaseQuantityBtn) {
        this.decreaseQuantityBtn.addEventListener("click", (event) => {
          event.preventDefault();
          this.updateQuantity(-this.quantityRules.increment);
        });
      }
    }

    openPopup(event) {
      const openPopupBtn = event.target.closest(".open-popup-btn");
      if (!openPopupBtn) return;

      const productCard = openPopupBtn.closest("product-card-element");
      const inventoryCard = productCard.querySelector(".invantory-logic-card");

      this.currentProductId = openPopupBtn.dataset.productId;
      this.currentVariantId = openPopupBtn.dataset.variantId;
      this.availableInventory = Math.max(
        0,
        parseInt(openPopupBtn.dataset.inventory, 10) || 0
      );
      this.displayInventory = Math.max(
        0,
        parseInt(openPopupBtn.dataset.displayInventory, 10) || 0
      );

      // Handle inventory display
      if (inventoryCard && this.showQuantitySpan) {
        this.showQuantitySpan.innerHTML = inventoryCard.innerHTML;
        this.showQuantitySpan.style.display = "block";
      }

      // Set up popup content
      this.popupProductTitle.textContent = openPopupBtn.dataset.productTitle;
      this.popupProductPrice.textContent = openPopupBtn.dataset.productPrice;
      this.addToCartBtn.dataset.variantId = this.currentVariantId;

      // Set up quantity rules
      this.quantityRules.min =
        parseInt(openPopupBtn.dataset.quantityMin, 10) || 1;
      this.quantityRules.max = openPopupBtn.dataset.quantityMax
        ? parseInt(openPopupBtn.dataset.quantityMax, 10)
        : null;
      this.quantityRules.increment =
        parseInt(openPopupBtn.dataset.quantityIncrement, 10) || 1;

      // Initialize quantity input
      this.quantityInput.min = this.quantityRules.min;
      this.quantityInput.max = this.getMaxQuantity();
      this.quantityInput.step = this.quantityRules.increment;
      this.quantityInput.value =
        this.availableInventory > 0 ? this.quantityRules.min : 0;

      // Set up add to cart handler
      this.addToCartBtn.removeEventListener("click", this.addToCartHandler);
      this.addToCartHandler = this.addToCart.bind(this);
      this.addToCartBtn.addEventListener("click", this.addToCartHandler);

      // Load image and show popup
      if (this.popupProductImage) {
        this.popupProductImage.src = openPopupBtn.dataset.image;
        this.popupProductImage.alt = openPopupBtn.dataset.productTitle;

        this.popupProductImage.onload = () => {
          this.popupContainer.style.display = "block";
          this.popupContainer.classList.add("popup-visible");
          this.updateQuantityButtonStates();
        };
      }
    }

    closePopup() {
      this.popupContainer.style.display = "none";
      this.popupContainer.classList.remove("popup-visible");
      this.currentProductId = null;
      this.currentVariantId = null;
      this.quantityInput.value = this.quantityRules.min;
    }

    getMaxQuantity() {
      const maxByRule = this.quantityRules.max || Infinity;
      const maxByInventory =
        Math.floor(
          (this.availableInventory - this.quantityRules.min) /
            this.quantityRules.increment
        ) *
          this.quantityRules.increment +
        this.quantityRules.min;
      return Math.min(maxByRule, maxByInventory);
    }

    validateQuantity() {
      let currentQuantity = parseInt(this.quantityInput.value, 10);
      if (isNaN(currentQuantity) || currentQuantity < this.quantityRules.min) {
        currentQuantity = this.quantityRules.min;
      } else {
        currentQuantity =
          Math.round(
            (currentQuantity - this.quantityRules.min) /
              this.quantityRules.increment
          ) *
            this.quantityRules.increment +
          this.quantityRules.min;
      }

      const maxQuantity = this.getMaxQuantity();
      if (currentQuantity > maxQuantity) {
        currentQuantity = maxQuantity;
      }

      this.quantityInput.value = currentQuantity;
      this.updateQuantityButtonStates();
    }

    updateQuantity(change) {
      let currentQuantity = parseInt(this.quantityInput.value, 10);
      currentQuantity += change;

      if (currentQuantity < this.quantityRules.min) {
        currentQuantity = this.quantityRules.min;
      } else {
        const maxQuantity = this.getMaxQuantity();
        if (currentQuantity > maxQuantity) {
          currentQuantity = maxQuantity;
        }
      }

      this.quantityInput.value = currentQuantity;
      this.updateQuantityButtonStates();
    }

    updateQuantityButtonStates() {
      const currentQuantity = parseInt(this.quantityInput.value, 10);
      const maxQuantity = this.getMaxQuantity();
      this.decreaseQuantityBtn.disabled =
        currentQuantity <= this.quantityRules.min;
      this.increaseQuantityBtn.disabled = currentQuantity >= maxQuantity;
    }

    addToCart(event) {
      event.preventDefault();

      if (!this.currentVariantId) {
        console.error("No variant selected");
        return;
      }

      this.addToCartBtn.style.pointerEvents = "none";

      const formData = {
        items: [
          {
            id: this.currentVariantId,
            quantity: parseInt(this.quantityInput.value, 10),
          },
        ],
      };

      fetch("/cart/add.js", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formData),
      })
        .then((response) => response.json())
        .then((data) => {
          this.closePopup();
          console.log("Added to cart:", data);
          this.updateCartIconBubble();
          this.showAddToCartSuccess();
        })
        .catch((error) => {
          console.error("Error adding to cart:", error);
          this.addToCartBtn.style.pointerEvents = "auto";
        });
    }

    updateCartIconBubble() {
      fetch(window.Shopify.routes.root + "cart.js")
        .then((response) => response.json())
        .then((cartData) => {
          let cartIcon = document.querySelector("#cart-icon-bubble");
          let cartIconBubble = document.querySelector(".cart-count-bubble");
          if (cartIconBubble) {
            cartIconBubble.textContent = cartData.item_count;
          } else {
            cartIconBubble = document.createElement("div");
            cartIconBubble.classList.add("cart-count-bubble");
            cartIconBubble.textContent = cartData.item_count;
            cartIcon.appendChild(cartIconBubble);
          }
        })
        .catch((error) => {
          console.error("Error fetching cart data:", error);
          this.addToCartBtn.style.pointerEvents = "auto";
        });
    }

    showAddToCartSuccess() {
      const successDiv = document.querySelector(".add-to-card-sucess");
      successDiv.classList.add("show");
      setTimeout(() => {
        successDiv.classList.remove("show");
      }, 3000);
    }
  }

  customElements.define(
    "custom-product-popup",
    class extends HTMLElement {
      connectedCallback() {
        new ProductPopup();
      }
    }
  );
});
